import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from './LinkDebitCard.messages';
import styles from './LinkDebitCard.module.css';
import { FormField } from '../../../../forms/formField/index';
import { normalizePostcode } from '../../../../helpers/normalizers';

export function BillingPostcodeQuestion() {
    return (
        <div className={styles.field}>
            <FormField
                label={<FormattedMessage {...messages.billingPostcode} />}
                className={classNames(styles.billingPostcode, 'fs-exclude')}
                name="billingPostcode"
                normalize={normalizePostcode}
                placeholder="e.g. N6 6NG"
            />
        </div>
    );
}
